export interface Workflow {
  id: string;
  name: string;
  description: string;
  relatedObjectType: RelatedObjectType;
  created: string;
  modified: string;
  versionCount: string;
  currentVersionNumber: string;
}

export interface AppointmentWorkflowStatus {
  id: string;
  workflowName: string;
  workflowVersionId: string;
  state: AppointmentState;
  stateLabel: string;
  created: string;
  modified: string;
  validStateTransitions: ValidStateTransition[];
  waitingRoomId: string;
  appointment: Appointment;
}

export interface Appointment {
  id: string;
  organizationId: string;
  patientId: string;
  sourceIdentifier: string;
  status: AppointmentStatusTypes;
  serviceCategory?: string;
  serviceType?: string;
  specialtyType?: string;
  appointmentType?: string;
  reasonCode?: string;
  financialInformationNumber?: string;
  description?: string;
  start: string;
  end?: string;
  durationM?: string;
  comment?: string;
  patientInstruction?: string;
  created?: string;
  modified?: string;
  patientDisplayName: string;
}

export enum RelatedObjectType {
  Appointments
}

export enum AppointmentState {
  new = "New",
  scheduled = "Scheduled",
  confirmation_requested = "Confirmation Request Sent",
  confirmed = "Confirmed",
  reschedule_requested = "Reschedule Requested",
  late_arrival = "Running Late",
  waiting = "Waiting",
  entrance_requested = "Entrance Request Sent",
  entered = "In Treatment",
  completed = "Completed",
  cancelled = "Cancelled"
}

export enum AppointmentStatusTypes {
  UNKNOWN = "unknown",
  PROPOSED = "proposed",
  PENDING = "pending",
  BOOKED = "booked",
  ARRIVED = "arrived",
  FULFILLED = "fulfilled",
  CANCELLED = "cancelled",
  NOSHOW = "noshow",
  ENTERED_IN_ERROR = "entered_in_error",
  CHECKED_IN = "checked_in",
  WAITLIST = "waitlist",
  WAITING = "waiting",
  ENTRANCE_REQUEST = "entrance_request",
  IN_TREATMENT = "in_treatment",
  COMPLETE = "complete"
}

export interface ValidStateTransition {
  uid: string;
  label: string;
  validForUi: boolean;
}

export enum ValidStateTransitionAction {
  new = "new",
  cancel = "cancel",
  schedule = "schedule",
  remind = "remind",
  confirm = "confirm",
  reschedule = "reschedule",
  late_arrival = "late_arrival",
  wait = "wait",
  request_entrance = "request_entrance",
  enter = "enter",
  complete = "complete"
}

export interface CreateSimpleAppointmentRequest {
  patientId: string;
  status?: string;
  description?: string;
  start: string;
}

export interface WaitingRoomAppointmentBatchResponse {
  created: string;
  id: string;
  recordCount: number;
  skippedCount: number;
  processedCount: number;
  status: string;
  waitingRoomId: string;
}
